<template>
  <div
    class="tw-flex tw-flex-col tw-h-[226px] tw-items-center tw-space-y-10 tw-justify-center tw-w-full tw-mx-auto"
  >
    <svg-vue
      icon="illustrations/star-page"
    />
    <div class="tw-flex tw-flex-col tw-gap-1 tw-items-center tw-text-center tw-w-1/2">
      <div class="tw-text-2xl tw-font-bold tw-text-neutral-900">
        No priority pages
      </div>
      <div class="tw-text-base tw-text-neutral-700">
        Go to the 'Available Pages' tab and click the star icon next to any page to mark it as a priority. I will optimise these pages before others in your list.
      </div>
    </div>
  </div>
</template>

